var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.isMobile)?_c('span',{staticClass:"col-key"},[_vm._v(_vm._s(((_vm.$tc("records." + _vm.columnName)) + " : ")))]):_vm._e(),_c('span',{staticClass:"col-text"},[_vm._v(_vm._s(_vm.recordDuration))])])}
var staticRenderFns = []

export { render, staticRenderFns }